import { GoogleWebSignIn } from './google_web_sign_in.js';

const { GoogleSignIn } = ( window as any ).Capacitor?.Plugins ?? {};
const isNative = !!GoogleSignIn;

export const GoogleSignInPlugin = {
  isAvailable(): boolean
  {
    return isNative || GoogleWebSignIn.isAvailable();
  },

  async getAndroidId(): Promise<string | null>
  {
    if ( !isNative ) return null;
    const { androidId } = await GoogleSignIn.getAndroidId();
    return androidId ?? null;
  },

  async getCachedId(): Promise<string | null>
  {
    if ( isNative )
    {
      const { googleId } = await GoogleSignIn.getCachedId();
      return googleId ?? null;
    }
    return GoogleWebSignIn.getCachedId();
  },

  setCachedId( id: string ): void
  {
    if ( !isNative ) GoogleWebSignIn.setCachedId( id );
  },

  async signIn(): Promise<{ idToken: string }>
  {
    if ( isNative ) return GoogleSignIn.signIn();
    return GoogleWebSignIn.signIn();
  },

  async signOut(): Promise<void>
  {
    if ( isNative )
    {
      await GoogleSignIn.signOut();
      return;
    }
    GoogleWebSignIn.signOut();
  },
};
